import {
  useFrontendOptionState,
  useLiveMarketDataStore,
  useOrderModifyDataStore,
} from "./store";
import { BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";

export const ContractSelector = () => {
  const frontendOptionState = useFrontendOptionState();
  const liveMarketDataStore = useLiveMarketDataStore();
  const orderModifyDataStore = useOrderModifyDataStore();

  function renderLiveData(conId: number) {
    const liveData = liveMarketDataStore.liveMarketData.find(
      (d) => d.conId === conId
    );

    if (!liveData) {
      return "";
    }

    return `[${liveData.bid ? liveData.bid.toFixed(2) : ""} | ${
      liveData.last ? liveData.last.toFixed(2) : ""
    } | ${liveData.ask ? liveData.ask.toFixed(2) : ""}] (Vol: ${
      liveData.volume ? liveData.volume : ""
    })`;
  }

  if (frontendOptionState.frontendOptionState.length === 0) {
    return <p className="text-gray-500">Empty list</p>;
  }

  function isSelected(conId: number) {
    return orderModifyDataStore.orderModifyData.conId === conId.toString();
  }

  return (
    <div className="mt-5">
      {frontendOptionState.frontendOptionState.map((opt) => (
        <div key={opt.readable_name} className="flex flex-row gap-2 mb-2 items-center">
          <div className="flex flex-col">
            <BiSolidUpArrow
              className={`cursor-pointer text-2xl ${
                isSelected(opt.conId) && orderModifyDataStore.orderModifyData.action === "BUY"
                  ? "text-blue-600"
                  : "text-gray-400"
              }`}
              onClick={() =>
                orderModifyDataStore.setNewOrderModifyData(
                  opt.conId.toString(),
                  "",
                  "BUY",
                  opt.readable_name,
                  "",
                  "",
                  ""
                )
              }
            />
            <BiSolidDownArrow
              className={`cursor-pointer text-2xl ${
                isSelected(opt.conId) && orderModifyDataStore.orderModifyData.action === "SELL"
                  ? "text-orange-500"
                  : "text-gray-400"
              }`}
              onClick={() =>
                orderModifyDataStore.setNewOrderModifyData(
                  opt.conId.toString(),
                  "",
                  "SELL",
                  opt.readable_name,
                  "",
                  "",
                  ""
                )
              }
            />
          </div>
          <div>
            <b>{opt.readable_name}</b>
            <p>{renderLiveData(opt.conId)}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
